import React from 'react'
import styles from './home.module.css'
import { IoStar } from "react-icons/io5";
import TestimonialCard from '../../Components/TestimonialCard/TestimonialCard'
import Section from '../../Components/Section/Section'
import CardStack from '../../Components/CardStack/CardStack'
import { useIsSmallScreen } from '../../hooks/useIsSmallScreen'
function Testimonials() {
    const isSmallScreen = useIsSmallScreen();

    const testimonials = [
        { quote: "Astraea’s sets are so lovely and detailed. You can genuinely tell how much love and effort she puts into her art. Not only is her work absolutely beautiful, but her presence makes the whole experience so enjoyable!", author: "Kaiden Margeson", rating: 5 },
        { quote: "Astraea is my favorite private nail technician because even when she was new to the profession, she was always up for a challenge. From short and sweet to long and bold, she’s the best nail technician I know.", author: "Clarissa Rayne", rating: 5 },
        { quote: "I’ve been going to Astraea since she started, and she seriously never misses!💕 She's so sweet, takes her time yet is efficient, and somehow brings every nail idea I have to life exactly how I pictured it.", author: "Lacey Aftuck", rating: 5 },
        { quote: "I’ve had the privilege of watching Astraea’s nail business grow since high school in 2022. It’s been so inspiring to see how far she's come– her dedication, creativity, and growth over the years has truly been impactful- I’m so grateful to witness her success. I always make sure to send people her way when looking to get their nails done, you'll never be disappointed!", author: "Clara", rating: 5 },
    ];

    return (

        <Section small shrink={isSmallScreen}>
            <div className={styles.testimonialsContainer}>
                <div data-reveal className={styles.homeHeaderContainer} style={{ textAlign: isSmallScreen ? 'center' : 'left' }}>
                    <h2 className={styles.smallHeader}>Testimonials</h2>
                    <h1 className={styles.largeHeader}>Feedback from my customers</h1>
                </div>
                {isSmallScreen ? (
                    <div data-reveal className={styles.revealItem}>
                        <CardStack label="Client testimonials">
                            {testimonials.map((testimonial, index) => (
                                <TestimonialCard key={index} {...testimonial} />
                            ))}
                        </CardStack>
                    </div>
                ) : (
                    <div className={styles.testimonialsGrid}>
                        {testimonials.map((testimonial, index) => (
                            <div data-reveal key={index} className={styles.revealItem}>
                                <TestimonialCard {...testimonial} />
                            </div>
                        ))}
                    </div>
                )}

            </div>
        </Section>
    )
}

export default Testimonials
